import {TargetLineItem, NameInLineItem} from '@wix/auto_sdk_ecom_current-cart';

export class ViolationLineItemTargetModel {
  public id: string;
  public name?: ViolationLineItemTargetName;

  constructor(params: ViolationLineItemTargetModel) {
    this.id = params.id;
    this.name = params.name;
  }

  public static fromCartV1(lineItemTarget?: TargetLineItem) {
    return new ViolationLineItemTargetModel({
      id: lineItemTarget._id,
      name: lineItemTarget?.name && sdkToViolationLineItemTargetName(lineItemTarget.name as NameInLineItem),
    });
  }
}

export enum ViolationLineItemTargetName {
  default = 'LINE_ITEM_DEFAULT',
}

const sdkToViolationLineItemTargetName = (name: NameInLineItem): ViolationLineItemTargetName => {
  const map: Record<NameInLineItem, ViolationLineItemTargetName> = {
    [NameInLineItem.LINE_ITEM_DEFAULT]: ViolationLineItemTargetName.default,
  };

  return map[name];
};
